/**
 * Extract the updatedAt timestamp in milliseconds from an entity object
 * @param {object} entity - Entity with updatedAt property
 * @returns {number|null} Timestamp in milliseconds, or null if not available
 */
export const getUpdatedAtMs = (entity) => {
  if (!entity?.updatedAt) {
    return null;
  }
  const timestamp = new Date(entity.updatedAt).getTime();
  return isNaN(timestamp) ? null : timestamp;
};